import { BIG_WIN_AMOUNT, BIG_WIN_STATE, MULTIPLIER_STATE } from '../../stateManagment/gameState';
import { delay } from '../../core/helpers/delay';

class BigWinService {
  constructor() {
    this.hasContinue = null;
  }

  oddSize = 15;

  maxWinLimit = Infinity;

  isMaxWin = false;

  isShowedState = false;

  checkBigWin(odd) {
    return odd >= this.oddSize;
  }

  checkMaxWin(amount) {
    return amount >= this.maxWinLimit;
  }

  get amount() {
    return BIG_WIN_AMOUNT.getValue();
  }

  set amount(value) {
    BIG_WIN_AMOUNT.next(value);
    return value;
  }

  get state() {
    return BIG_WIN_STATE.getValue();
  }

  resetAmount() {
    this.amount = 0;
  }

  startBigWin() {
    this._timer?.cancel();
    this.isShowedState = false;
    BIG_WIN_STATE.next(true);
    this._timer = delay(() => {
      this.isShowedState = true;
    }, 2000);
  }

  closeBigWin() {
    BIG_WIN_STATE.next(false);
    this.resetAmount();
    if (this.callback && typeof this.callback === 'function') {
      this.callback();
      this.callback = null;
    }
  }

  subscribeState(...args) {
    return BIG_WIN_STATE.subscribe(...args);
  }

  checkSpinAndStartBigWin(data) {
    if (data) {
      const { odd, winAmount } = data;

      if (this.checkMaxWin(winAmount)) {
        this.isMaxWin = true;
        this.amount = winAmount;
        this.startBigWin();
        return true;
      } else if (this.checkBigWin(odd)) {
        this.isMaxWin = false;
        this.amount = winAmount;
        this.startBigWin();
        return true;
      }
      return this.checkBigWin(odd);
    }
  }

  checkBonusSpinAndStartBigWin(data) {
    if (data) {
      const { odd, winAmount, totalWinAmount } = data;

      if (this.checkMaxWin(totalWinAmount)) {
        this.isMaxWin = true;
        this.amount = totalWinAmount;
        this.startBigWin();
        return true;
      }

      const state = this.checkBigWin(odd + MULTIPLIER_STATE.getValue());
      if (state) {
        this.isMaxWin = false;
        this.amount = winAmount;
        this.startBigWin();
      }
      return state;
    }
  }

  setContinueCallBack(value) {
    this.callBack = value;
  }

  setResumeCallBack(value) {
    this.resumeCallBack = value;
  }

  has() {
    return this.hasContinue;
  }

  setHas() {
    this.hasContinue = true;
  }

  continue() {
    this.callBack();
  }

  resume() {
    this.resumeCallBack && this.resumeCallBack();
  }

  addCallback(callback) {
    this.callback = callback;
  }
}

export const bigWinService = new BigWinService();
